// <!----- Style Dynamic Buy Button Code Start -----> //

(function styleAddToCartInShadow() {
  const CSS = `
    .product-form__submit {
      font-weight: 800;
      font-size: 15px;
      padding: 15px;
      border-radius: 13px;
    }
  `;

  // Saari shadow roots recursively dhoondo (querySelector shadow boundary cross nahi karta)
  function findShadowRoots(root, found = []) {
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) {
        found.push(el.shadowRoot);
        findShadowRoots(el.shadowRoot, found);
      }
    });
    return found;
  }

  function injectStyle() {
    let done = false;
    findShadowRoots(document).forEach((sr) => {
      const btn = sr.querySelector('button[name="add"], .product-form__submit');
      if (btn && !sr.querySelector('style[data-custom-atc]')) {
        const style = document.createElement('style');
        style.setAttribute('data-custom-atc', '');
        style.textContent = CSS;
        sr.appendChild(style);
        done = true;
      }
    });
    return done;
  }

  // Abhi try karo; agar shadow DOM late load hota hai to observer se retry
  if (!injectStyle()) {
    const obs = new MutationObserver(() => {
      if (injectStyle()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 10000); // safety, 10s baad band
  }
})();

// <!----- Style Dynamic Buy Button Code End -----> //

// <!----- Update variant Name On Variant Click Code Start -----> //

document.addEventListener('DOMContentLoaded', () => {
  const variantName = document.querySelector('.product-option_name-row .product-variant-name');
  const variantImages = document.querySelectorAll('.product-variant-image');

  function setVariantName(value) {
    if (variantName) variantName.textContent = value;
  }

  const checked = document.querySelector('.product-variant-images input[type="radio"]:checked');
  if (checked) setVariantName(checked.value);

  variantImages.forEach((label) => {
    label.addEventListener('click', () => {
      const input = document.getElementById(label.getAttribute('for'));
      if (input) setVariantName(input.value);
    });
  });
});

// <!----- Update variant Name On Variant Click Code End -----> //

// <!----- Update Price On Subscription Widget Click Code Start -----> //

/* =====================================================================
   Fireside | Apply the selected Bold purchase-option price on the PDP
   ---------------------------------------------------------------------
   Copies the selected Purchase Option's .po-block__price into:
     - .sticky-atc__price                     (sticky bar)   -> "$ 0.00"
     - .price__regular .price-item--regular   (main price)   -> "$ 0.00 USD"

   Key rule: we do NOTHING until the shopper actually picks an option.
   On load the theme already shows the correct default (one-time / variant)
   price, so we leave it alone. This kills the load-time flash where the
   price briefly jumped to the subscription value during Bold's init.

   The setText() guard keeps our own writes idempotent so the body-level
   MutationObserver never loops on itself, and it lets us re-apply the
   price after Dawn re-renders on a variant change.
   ===================================================================== */
(function () {
  'use strict';

  var PRODUCT_SELECTOR = '.main-product';
  var GROUP_RADIO = 'input[name="bsub-selling-plan-group"]';

  // Flip to true only on a genuine user selection (see init()).
  var userEngaged = false;

  // Each target gets "$ <amount><suffix>".
  // .price__regular scope avoids the strikethrough .price-item--regular
  // that lives inside .price__sale.
  var TARGETS = [
    { selector: '.sticky-atc__price',                    suffix: '' },
    { selector: '.price__regular .price-item--regular',  suffix: ' USD' }
  ];

  // Pull the numeric amount out of "$18.99" / "$ 17.09" -> "18.99"
  function extractAmount(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^\d.,]/g, '').replace(/,/g, '');
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : value.toFixed(2);
  }

  // Write only when the value actually changes (prevents observer loops).
  function setText(el, value) {
    if (el.textContent.trim() !== value) {
      el.textContent = value;
    }
  }

  function syncPrices() {
    if (!userEngaged) return; // hands off until the shopper chooses

    var product = document.querySelector(PRODUCT_SELECTOR);
    if (!product) return;

    var checked = product.querySelector(GROUP_RADIO + ':checked');
    if (!checked) return;

    // The price lives inside the same group label as the checked radio.
    var group = checked.closest('.bsub-widget__group-label') || checked.parentElement;
    var priceEl = group ? group.querySelector('.po-block__price') : null;
    if (!priceEl) return;

    var amount = extractAmount(priceEl.textContent);
    if (!amount) return;

    TARGETS.forEach(function (t) {
      var value = '$ ' + amount + t.suffix;
      document.querySelectorAll(t.selector).forEach(function (el) {
        setText(el, value);
      });
    });
  }

  function engage() {
    userEngaged = true;
    requestAnimationFrame(syncPrices);
  }

  function init() {
    var product = document.querySelector(PRODUCT_SELECTOR);
    if (!product) return;

    // NO sync on load: the theme already shows the correct default price.

    // Only a real (isTrusted) user interaction counts as engagement, so
    // Bold's own init events can never trigger an early price change.
    product.addEventListener('change', function (e) {
      if (e.isTrusted && e.target && e.target.matches(GROUP_RADIO)) {
        engage();
      }
    });

    product.addEventListener('click', function (e) {
      if (e.isTrusted && e.target.closest && e.target.closest('.bsub-widget__group-header')) {
        engage();
      }
    });

    // After engagement, keep our price applied even when Dawn re-renders
    // the price / sticky bar on a variant change.
    if (window.MutationObserver) {
      var pending;
      new MutationObserver(function () {
        cancelAnimationFrame(pending);
        pending = requestAnimationFrame(syncPrices);
      }).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// <!----- Update Price On Subscription Widget Click Code End -----> //

// <!----- Smooth Scroll On Testimonials Section Code Start -----> //

document.addEventListener('click', (e) => {
  const link = e.target.closest('#stamped-main-widget .stamped-reviews-ul li a');
  if (!link) return;

  const target = document.getElementById('stamped-main-widget');
  if (!target) return;

  // preventDefault sirf href="#" wale jump ko rokta hai.
  // Stamped ka apna inline onclick (StampedFn.pageReviews) alag se chalta rahega.
  e.preventDefault();

  const header = document.querySelector('.section-header')
               || document.querySelector('sticky-header');
  const offset = header ? header.offsetHeight : 0;
  const top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;

  window.scrollTo({ top, behavior: 'smooth' });
});

// <!----- Smooth Scroll On Testimonials Section Code End -----> //